export const forgerockRoleKey =
  "urn:ciamuk-v1:non-unique-attribute:employer:shared:simple-entitlement-v1"

export const forgerockCashplanRoleKey =
  "urn:ciamuk-v1:non-unique-attribute:employer:cashplan:simple-entitlement-v1"


export const cashplanRoleScope = "uuk-cashplan-employer";

export const userRoles = {
  normal: "user", // standard
  admin: "admin", //admin
  super: "super-user", // full user
  enhanced: "enhanced", //enhanced
  cashplan: "cashplan", // cashplan access
  helpAtHandSSO: "help-at-hand-sso", // help at hand sso access
  helpAtHandMi: "help-at-hand-mi", // help at hand mi access
} as const;

export const userManagementAPIRoles = {
  normal: "normal",
  admin: "admin",
  super: "super",
  enhanced: "enhanced",
} as const;

export const UserRolesLabels = {
  [userRoles.normal]: "Restricted Portal User",
  [userRoles.enhanced]: "Portal User",
  [userRoles.super]: "Portal Manager ",
  [userRoles.admin]: "Portal Administrator",
} as const;

export const userRolesOptions: {
  label: UserRolesLabelsType;
  value: userRolesType;
}[] = [
  { label: UserRolesLabels[userRoles.admin], value: userRoles.admin },
  { label: UserRolesLabels[userRoles.super], value: userRoles.super },
  { label: UserRolesLabels[userRoles.enhanced], value: userRoles.enhanced },
  { label: UserRolesLabels[userRoles.normal], value: userRoles.normal },
];

export type userRolesType = (typeof userRoles)[keyof typeof userRoles];

export type UserRolesLabelsType =
  | (typeof UserRolesLabels)[keyof typeof UserRolesLabels]
  | undefined;